import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AsyncPipe, NgClass } from '@angular/common';
import { Role } from '../../enums/role';
import { RoleCssPipe } from '../../pipes/role-css.pipe';
import { RoleLabelPipe } from '../../pipes/role-label.pipe';

@Component({
  selector: 'app-role',
  imports: [RoleLabelPipe, AsyncPipe, RoleCssPipe, NgClass],
  templateUrl: './role.component.html',
  styleUrl: './role.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RoleComponent {
  @Input({ required: true }) public role!: Role;
}
